import { createFeatureSelector, createSelector } from '@ngrx/store';
import type { PlatformAdminListItem } from './platform-admins.models';
import {
  PLATFORM_ADMINS_FEATURE_KEY,
  type PlatformAdminsState,
} from './platform-admins.reducer';

export const selectPlatformAdminsState =
  createFeatureSelector<PlatformAdminsState>(PLATFORM_ADMINS_FEATURE_KEY);

export const selectAllAdmins = createSelector(
  selectPlatformAdminsState,
  (state): PlatformAdminListItem[] => state.admins
);

export const selectAdminsLoading = createSelector(
  selectPlatformAdminsState,
  (state): boolean => state.loading
);

export const selectAdminsMutating = createSelector(
  selectPlatformAdminsState,
  (state): boolean => state.mutating
);

export const selectAdminsError = createSelector(
  selectPlatformAdminsState,
  (state): string | null => state.error
);
